module.exports = __webpack_public_path__ + "static/media/anage-experiencia.1f666730.webp";